<script>
	import { onMount, createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
  import mapboxgl from 'maplibre-gl';
  import bbox from '@turf/bbox';
  import * as turf from '@turf/turf';
	import * as helpers from '@turf/helpers';
  import { fetchData } from '../utils/Data.svelte'
  import Chart from 'chart.js/auto';
	import { save, refresh, trash, print as printIcon } from 'ionicons/icons/index.mjs';

	const dispatch = createEventDispatcher();
  export let modal;
  export let tooltips;
  let loaded = false;
  const letters = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];

  onMount(async () => {
    var map = new mapboxgl.Map({
      container: "mb-preview",
      minZoom: 0,
      maxZoom: 20,
      style: 'https://api.maptiler.com/maps/streets/style.json?key=02rAug6816zxBfqKVHYR',
      attributionControl: false,
			pitchWithRotate: false
		});

    var geometry = helpers.lineString(modal.feature.geometry.coordinates);
    const distance = turf.default.length(geometry, {units: 'miles'});
    const segments = turf.default.lineChunk(geometry, distance/19, {units: 'miles'});
    let points = [{
      type: "Feature",
      properties: {
        label: "A"
      },
      geometry: {
        type: "Point",
        coordinates: [segments.features[0].geometry.coordinates[0][0], segments.features[0].geometry.coordinates[0][1]]
      }
    }];

    map.on('load', () => {
      map.addSource('profile', {
        "type": "geojson",
        "data": {
          "type": "FeatureCollection",
            "features": [modal.feature]
          }
      });

      map.addSource('points', {
        "type": "geojson",
        "data": {
          "type": "FeatureCollection",
            "features": points
          }
      });

      map.addLayer({
        "id": "profile",
        "source": "profile",
        "type": "line",
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        "paint": {
          'line-color': '#007cbf',
          'line-width': 4
        }
      });

      map.addLayer({
        "id": "points",
        "source": "points",
        "type": "circle",
        "paint": {
          'circle-color': '#007cbf',
          'circle-radius': 5
        }
      });

      map.addLayer({
        'id': 'labels',
        'type': 'symbol',
        'source': 'points',
        'layout': {
          'text-field': ['get', 'label'],
          'text-variable-anchor': ['left'],
          'text-radial-offset': 0.5
        }
      });

			var bounds = bbox(geometry);
			map.fitBounds(bounds, {
					padding: 20
			});
    })

    let elevations = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let ct = 0;
    let endpoint = "ky";
    var url = new URL("https://kyraster.ky.gov/arcgis/rest/services/ElevationServices/Ky_DEM_KYAPED_5FT/ImageServer/identify");
		var params = {
      returnGeometry: false,
      returnCatalogItems: false,
      geometry: JSON.stringify({
          x: segments.features[0].geometry.coordinates[0][0],
          y: segments.features[0].geometry.coordinates[0][1],
          spatialReference: {
              wkid: 4326
          }
      }),
      geometryType: "esriGeometryPoint",
      f: "json"
    }
		url.search = new URLSearchParams(params).toString();
    let [res, err] = await fetchData(url);
    if (err || res.error || res.value == "NoData") {
      endpoint = "usgs";
      url = new URL("https://nationalmap.gov/epqs/pqs.php");
      params = {
        x: segments.features[0].geometry.coordinates[0][0],
        y: segments.features[0].geometry.coordinates[0][1],
        units: "feet",
        output: "json"
      }
      url.search = new URLSearchParams(params).toString();
      let [res, err] = await fetchData(url);
      if (err || res.error || res.USGS_Elevation_Point_Query_Service.Elevation_Query.Elevation == "-1000000") {
        return
      }
      else {
        elevations[0] = res.USGS_Elevation_Point_Query_Service.Elevation_Query.Elevation;
      }
    }
    else {
      elevations[0] = res.value;
    }
    segments.features.map(async function (f, i) {
      var feature = null;
      if (i == 18) {
        feature = segments.features[i]
        points.push({
          type: "Feature",
          properties: {
            label: letters[i + 1]
          },
          geometry: {
            type: "Point",
            coordinates: feature.geometry.coordinates[1]
          }
        })
        if (endpoint == "usgs") {
          params.x = feature.geometry.coordinates[1][0];
          params.y = feature.geometry.coordinates[1][1];
        }
        else if (endpoint == "ky") {
          params.geometry = JSON.stringify({
              x: feature.geometry.coordinates[1][0],
              y: feature.geometry.coordinates[1][1],
              spatialReference: {
                  wkid: 4326
              }
          })
        }
      }
      else {
        feature = segments.features[i + 1]
        points.push({
          type: "Feature",
          properties: {
            label: letters[i + 1]
          },
          geometry: {
            type: "Point",
            coordinates: feature.geometry.coordinates[0]
          }
        })
        if (endpoint == "usgs") {
          params.x = feature.geometry.coordinates[0][0];
          params.y = feature.geometry.coordinates[0][1];
        }
        else if (endpoint == "ky") {
          params.geometry = JSON.stringify({
              x: feature.geometry.coordinates[0][0],
              y: feature.geometry.coordinates[0][1],
              spatialReference: {
                  wkid: 4326
              }
          })
        }
      }
      ct++;
      url.search = new URLSearchParams(params).toString();
      let [res, err] = await fetchData(url);
      if (!err && !res.error) {
        if (res.value && res.value != "NoData") {
          elevations[i+1] = res.value;
        }
        else if (res.USGS_Elevation_Point_Query_Service && res.USGS_Elevation_Point_Query_Service.Elevation_Query.Elevation != "-1000000") {
          elevations[i+1] = res.USGS_Elevation_Point_Query_Service.Elevation_Query.Elevation;
        }
      }
      ct--;
      if (ct == 0)
        generateChart(elevations, distance);
    })
  });

  function generateChart(elevations, distance) {
    var labels = [];

    for (var i = 0; i < 20; i++) {
        labels.push(
            "[" + letters[i] + "] " + (i/19 * (distance * 5280)).toFixed(2)
        )
    }

    var config = {
        type: 'line',
        data: {
            labels: labels,
            datasets: [{
                data: elevations
            }]
        },
        options: {
            scales: {
              x: {
                title: {
                  display: true,
                  text: "distance (ft)"
                }
              },
              y: {
                title: {
                  display: true,
                  text: "elevation (ft)"
                }
              },
            },
            plugins: {
                legend: {
                    display: false
                }
            }
        }
    };
    loaded = true;
    new Chart(document.getElementById("chart"), config);
  }

	function sendMessage(message) {
		dispatch('message', message);
	}

  function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
  }

  function printHandler(e) {
		e.currentTarget.blur();
    print("summary");
  }

  function deferred() {
    let thens = []
    let catches = []
  
    let status
    let resolvedValue
    let rejectedError
  
    return {
      resolve: value => {
        status = 'resolved'
        resolvedValue = value
        thens.forEach(t => t(value))
        thens = [] // Avoid memleaks.
      },
      reject: error => {
        status = 'rejected'
        rejectedError = error
        catches.forEach(c => c(error))
        catches = [] // Avoid memleaks.
      },
      then: cb => {
        if (status === 'resolved') {
          cb(resolvedValue)
        } else {
          thens.unshift(cb)
        }
      },
      catch: cb => {
        if (status === 'rejected') {
          cb(rejectedError)
        } else {
          catches.unshift(cb)
        }
      },
    }
  }

  function printFrame(frameWindow, content, options) {
      // Print the selected window/iframe
      var def = deferred();
      try {
          frameWindow = frameWindow.contentWindow || frameWindow.contentDocument || frameWindow;
          frameWindow.open();
          if (frameWindow.write) {
            frameWindow.write(content);
          }
          else {
            frameWindow.document.write(content);
          }
          frameWindow.close();
          var printed = false,
          callPrint = function () {
              if (printed) {
                  return;
              }
              // Fix for IE : Allow it to render the iframe
              frameWindow.focus();
              try {
                  // Fix for IE11 - printng the whole page instead of the iframe content
                  if (!frameWindow.document.execCommand('print', false, null)) {
                      // document.execCommand returns false if it failed -http://stackoverflow.com/a/21336448/937891
                      frameWindow.print();
                  }
                  // focus body as it is losing focus in iPad and content not getting printed
                  document.querySelector('body').focus();
              } catch (e) {
                console.log(e);
                  frameWindow.print();
              }
              frameWindow.close();
              printed = true;
              def.resolve();
          };
          frameWindow.addEventListener("load", callPrint);
          setTimeout(callPrint, options.timeout);
      } catch (err) {
        def.reject(err);
      }
      return def;
  }

  function printContentInIFrame(content, options) {
      var iframe = document.createElement('iframe');
      iframe.setAttribute("style", "height:0;width:0;border:0;position:absolute;top:-999;left:-999;");
      document.querySelector("body").appendChild(iframe);
      return printFrame(iframe, content, options);
  }

  function printContentInNewWindow(content, options) {
      // Open a new window and print selected content
      var frameWindow = window.open();
      return printFrame(frameWindow, content, options);
  }

  function print(id, options) {
      // Print a given set of elements
      var element = document.getElementById(id);
      
      // Default options
      var defaults = {
          iframe: true,
          timeout: 750
      };
      // Merge with user-options
      options = {...defaults, ...options};

      // Create a copy of the element to print
      var copy = element.cloneNode(true);
      // Wrap it in a span to get the HTML markup string
      copy = document.createElement('span').appendChild(copy);

      if (options.iframe) {
          // Use an iframe for printing
          try {
              printContentInIFrame(copy.innerHTML, options);
          } catch (e) {
              console.log(e);
              printContentInNewWindow(copy.innerHTML, options);
          }
      } else {
          // Use a new window for printing
          printContentInNewWindow(copy.innerHTML, options);
      }
      return this;
  };
</script>

<div class="modal modal-lg active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Profile</div>
                </div>
                <div class="tile-action">
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div id="summary" class="modal-body">
          <div id="mb-preview" />
          {#if !loaded}
            <div id="loader" class="preloader-wrapper">
                <div class="preloader">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
          {/if}
          <canvas id="chart"></canvas>
        </div>
    </div>
</div>

<style>
  #summary {
    display: flex;
    flex-direction: column;
  }
  #mb-preview {
    width: 100%;
    height: 300px;
    flex: 0 0 300px;
  }
  #loader {
    padding-top: 100px;
    flex: 0 0 100px;
  }
  #chart {
    width: 100%;
    flex: 1 1 auto;
  }
	.modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 0;
        height: calc(100vh - 2.1rem);
    }
    ::-webkit-scrollbar {
      width: 6px;
      background-color: #f7f8f9;
    }
	  ::-webkit-scrollbar-thumb {
	  	background-color: rgba(122,129,132, 1);
    }
</style>